import React, {useEffect, useState} from 'react';
import './rsuite-default.css';
import {DateRangePicker} from "rsuite";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";

const StyledPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'altStyle'
})(({ altStyle }) => ({
  padding: altStyle ? 2 : 8,
  background: '#fff',
  display: 'inline-block',
  marginBottom: altStyle ? 0 : 20,
  marginRight: altStyle ? 0 : 32,
  position: 'relative'
}));

const Title = styled('div')({
  position: 'absolute',
  top: -8,
  left: 10,
  fontSize: 12,
  zIndex: 100
});

export default function DateRangeNew({onChange, value, altStyle= false, title='', style}) {
  const [locValue, setLocValue] = useState(value);

  const onDateChange = date => {
    setLocValue(date);
    if (date && date.length) {
      onChange(date);
    }
  };

  useEffect(() => {
    setLocValue(value);
  }, [value]);

  return (
    <StyledPaper altStyle={altStyle} style={style}>
      {title && <Title>{title}</Title>}
      <DateRangePicker value={locValue} appearance={'subtle'} isoWeek={true} onChange={onDateChange}/>
    </StyledPaper>
  );
}
